import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import api from '../services/api';
import { getComuniByProvincia, searchComuni, getDefaultComuni } from '../utils/comuni';
import { 
  ChevronRightIcon, 
  MagnifyingGlassIcon,
  InformationCircleIcon,
  ChevronDownIcon
} from '@heroicons/react/24/outline';

// Dati delle province italiane
const PROVINCE_ITALIANE = [
  { codice: '001', nome: 'Torino', sigla: 'TO', regione: 'Piemonte' },
  { codice: '002', nome: 'Vercelli', sigla: 'VC', regione: 'Piemonte' },
  { codice: '003', nome: 'Novara', sigla: 'NO', regione: 'Piemonte' },
  { codice: '004', nome: 'Cuneo', sigla: 'CN', regione: 'Piemonte' },
  { codice: '005', nome: 'Asti', sigla: 'AT', regione: 'Piemonte' },
  { codice: '006', nome: 'Alessandria', sigla: 'AL', regione: 'Piemonte' },
  { codice: '007', nome: 'Valle d\'Aosta', sigla: 'AO', regione: 'Valle d\'Aosta' },
  { codice: '008', nome: 'Imperia', sigla: 'IM', regione: 'Liguria' },
  { codice: '009', nome: 'Savona', sigla: 'SV', regione: 'Liguria' },
  { codice: '010', nome: 'Genova', sigla: 'GE', regione: 'Liguria' },
  { codice: '011', nome: 'La Spezia', sigla: 'SP', regione: 'Liguria' },
  { codice: '012', nome: 'Varese', sigla: 'VA', regione: 'Lombardia' },
  { codice: '013', nome: 'Como', sigla: 'CO', regione: 'Lombardia' },
  { codice: '014', nome: 'Sondrio', sigla: 'SO', regione: 'Lombardia' },
  { codice: '015', nome: 'Milano', sigla: 'MI', regione: 'Lombardia' },
  { codice: '016', nome: 'Bergamo', sigla: 'BG', regione: 'Lombardia' },
  { codice: '017', nome: 'Brescia', sigla: 'BS', regione: 'Lombardia' },
  { codice: '018', nome: 'Pavia', sigla: 'PV', regione: 'Lombardia' },
  { codice: '019', nome: 'Cremona', sigla: 'CR', regione: 'Lombardia' },
  { codice: '020', nome: 'Mantova', sigla: 'MN', regione: 'Lombardia' },
  { codice: '021', nome: 'Bolzano', sigla: 'BZ', regione: 'Trentino Alto Adige' },
  { codice: '022', nome: 'Trento', sigla: 'TN', regione: 'Trentino Alto Adige' },
  { codice: '023', nome: 'Verona', sigla: 'VR', regione: 'Veneto' },
  { codice: '024', nome: 'Vicenza', sigla: 'VI', regione: 'Veneto' },
  { codice: '025', nome: 'Belluno', sigla: 'BL', regione: 'Veneto' },
  { codice: '026', nome: 'Treviso', sigla: 'TV', regione: 'Veneto' },
  { codice: '027', nome: 'Venezia', sigla: 'VE', regione: 'Veneto' },
  { codice: '028', nome: 'Padova', sigla: 'PD', regione: 'Veneto' },
  { codice: '029', nome: 'Rovigo', sigla: 'RO', regione: 'Veneto' },
  { codice: '030', nome: 'Udine', sigla: 'UD', regione: 'Friuli Venezia Giulia' },
  { codice: '031', nome: 'Gorizia', sigla: 'GO', regione: 'Friuli Venezia Giulia' },
  { codice: '032', nome: 'Trieste', sigla: 'TS', regione: 'Friuli Venezia Giulia' },
  { codice: '033', nome: 'Piacenza', sigla: 'PC', regione: 'Emilia Romagna' },
  { codice: '034', nome: 'Parma', sigla: 'PR', regione: 'Emilia Romagna' },
  { codice: '035', nome: 'Reggio nell\'Emilia', sigla: 'RE', regione: 'Emilia Romagna' },
  { codice: '036', nome: 'Modena', sigla: 'MO', regione: 'Emilia Romagna' },
  { codice: '037', nome: 'Bologna', sigla: 'BO', regione: 'Emilia Romagna' },
  { codice: '038', nome: 'Ferrara', sigla: 'FE', regione: 'Emilia Romagna' },
  { codice: '039', nome: 'Ravenna', sigla: 'RA', regione: 'Emilia Romagna' },
  { codice: '040', nome: 'Forlì-Cesena', sigla: 'FC', regione: 'Emilia Romagna' },
  { codice: '041', nome: 'Pesaro e Urbino', sigla: 'PU', regione: 'Marche' },
  { codice: '042', nome: 'Ancona', sigla: 'AN', regione: 'Marche' },
  { codice: '043', nome: 'Macerata', sigla: 'MC', regione: 'Marche' },
  { codice: '044', nome: 'Ascoli Piceno', sigla: 'AP', regione: 'Marche' },
  { codice: '045', nome: 'Massa-Carrara', sigla: 'MS', regione: 'Toscana' },
  { codice: '046', nome: 'Lucca', sigla: 'LU', regione: 'Toscana' },
  { codice: '047', nome: 'Pistoia', sigla: 'PT', regione: 'Toscana' },
  { codice: '048', nome: 'Firenze', sigla: 'FI', regione: 'Toscana' },
  { codice: '049', nome: 'Livorno', sigla: 'LI', regione: 'Toscana' },
  { codice: '050', nome: 'Pisa', sigla: 'PI', regione: 'Toscana' },
  { codice: '051', nome: 'Arezzo', sigla: 'AR', regione: 'Toscana' },
  { codice: '052', nome: 'Siena', sigla: 'SI', regione: 'Toscana' },
  { codice: '053', nome: 'Grosseto', sigla: 'GR', regione: 'Toscana' },
  { codice: '054', nome: 'Perugia', sigla: 'PG', regione: 'Umbria' },
  { codice: '055', nome: 'Terni', sigla: 'TR', regione: 'Umbria' },
  { codice: '056', nome: 'Viterbo', sigla: 'VT', regione: 'Lazio' },
  { codice: '057', nome: 'Rieti', sigla: 'RI', regione: 'Lazio' },
  { codice: '058', nome: 'Roma', sigla: 'RM', regione: 'Lazio' },
  { codice: '059', nome: 'Latina', sigla: 'LT', regione: 'Lazio' },
  { codice: '060', nome: 'Frosinone', sigla: 'FR', regione: 'Lazio' },
  { codice: '061', nome: 'Caserta', sigla: 'CE', regione: 'Campania' },
  { codice: '062', nome: 'Benevento', sigla: 'BN', regione: 'Campania' },
  { codice: '063', nome: 'Napoli', sigla: 'NA', regione: 'Campania' },
  { codice: '064', nome: 'Avellino', sigla: 'AV', regione: 'Campania' },
  { codice: '065', nome: 'Salerno', sigla: 'SA', regione: 'Campania' },
  { codice: '066', nome: 'L\'Aquila', sigla: 'AQ', regione: 'Abruzzo' },
  { codice: '067', nome: 'Teramo', sigla: 'TE', regione: 'Abruzzo' },
  { codice: '068', nome: 'Pescara', sigla: 'PE', regione: 'Abruzzo' },
  { codice: '069', nome: 'Chieti', sigla: 'CH', regione: 'Abruzzo' },
  { codice: '070', nome: 'Campobasso', sigla: 'CB', regione: 'Molise' },
  { codice: '071', nome: 'Foggia', sigla: 'FG', regione: 'Puglia' },
  { codice: '072', nome: 'Bari', sigla: 'BA', regione: 'Puglia' },
  { codice: '073', nome: 'Taranto', sigla: 'TA', regione: 'Puglia' },
  { codice: '074', nome: 'Brindisi', sigla: 'BR', regione: 'Puglia' },
  { codice: '075', nome: 'Lecce', sigla: 'LE', regione: 'Puglia' },
  { codice: '076', nome: 'Potenza', sigla: 'PZ', regione: 'Basilicata' },
  { codice: '077', nome: 'Matera', sigla: 'MT', regione: 'Basilicata' },
  { codice: '078', nome: 'Cosenza', sigla: 'CS', regione: 'Calabria' },
  { codice: '079', nome: 'Catanzaro', sigla: 'CZ', regione: 'Calabria' },
  { codice: '080', nome: 'Reggio Calabria', sigla: 'RC', regione: 'Calabria' },
  { codice: '081', nome: 'Trapani', sigla: 'TP', regione: 'Sicilia' },
  { codice: '082', nome: 'Palermo', sigla: 'PA', regione: 'Sicilia' },
  { codice: '083', nome: 'Messina', sigla: 'ME', regione: 'Sicilia' },
  { codice: '084', nome: 'Agrigento', sigla: 'AG', regione: 'Sicilia' },
  { codice: '085', nome: 'Caltanissetta', sigla: 'CL', regione: 'Sicilia' },
  { codice: '086', nome: 'Enna', sigla: 'EN', regione: 'Sicilia' },
  { codice: '087', nome: 'Catania', sigla: 'CT', regione: 'Sicilia' },
  { codice: '088', nome: 'Ragusa', sigla: 'RG', regione: 'Sicilia' },
  { codice: '089', nome: 'Siracusa', sigla: 'SR', regione: 'Sicilia' },
  { codice: '090', nome: 'Sassari', sigla: 'SS', regione: 'Sardegna' },
  { codice: '091', nome: 'Nuoro', sigla: 'NU', regione: 'Sardegna' },
  { codice: '092', nome: 'Cagliari', sigla: 'CA', regione: 'Sardegna' },
  { codice: '093', nome: 'Pordenone', sigla: 'PN', regione: 'Friuli Venezia Giulia' },
  { codice: '094', nome: 'Isernia', sigla: 'IS', regione: 'Molise' },
  { codice: '095', nome: 'Oristano', sigla: 'OR', regione: 'Sardegna' },
  { codice: '096', nome: 'Biella', sigla: 'BI', regione: 'Piemonte' },
  { codice: '097', nome: 'Lecco', sigla: 'LC', regione: 'Lombardia' },
  { codice: '098', nome: 'Lodi', sigla: 'LO', regione: 'Lombardia' },
  { codice: '099', nome: 'Rimini', sigla: 'RN', regione: 'Emilia Romagna' },
  { codice: '100', nome: 'Prato', sigla: 'PO', regione: 'Toscana' },
  { codice: '101', nome: 'Crotone', sigla: 'KR', regione: 'Calabria' },
  { codice: '102', nome: 'Vibo Valentia', sigla: 'VV', regione: 'Calabria' },
  { codice: '103', nome: 'Verbano-Cusio-Ossola', sigla: 'VB', regione: 'Piemonte' },
  { codice: '108', nome: 'Monza e della Brianza', sigla: 'MB', regione: 'Lombardia' },
  { codice: '109', nome: 'Fermo', sigla: 'FM', regione: 'Marche' },
  { codice: '110', nome: 'Barletta-Andria-Trani', sigla: 'BT', regione: 'Puglia' },
  { codice: '111', nome: 'Sud Sardegna', sigla: 'SU', regione: 'Sardegna' }
];

const ClientForm = ({ isEdit = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEditing = isEdit || Boolean(id);
  
  // Stato iniziale del form
  const initialFormState = {
    tipo_cliente: 'privato',
    nome: '',
    cognome: '',
    codice_fiscale: '',
    tipo_contratto: '',
    ragione_sociale: '',
    partita_iva: '',
    referente: '',
    pec: '',
    codice_univoco: '',
    tipo_societa: '',
    indirizzo: '',
    citta: '',
    provincia: '',
    cap: '',
    email: '',
    telefono: '',
    iban: '',
    stato: 'prospect',
    responsabileId: null
  };
  
  const [formData, setFormData] = useState(initialFormState);
  const [loading, setLoading] = useState(isEditing);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [showOwnerDropdown, setShowOwnerDropdown] = useState(false);
  const [showProvinciaDropdown, setShowProvinciaDropdown] = useState(false);
  const [showCittaDropdown, setShowCittaDropdown] = useState(false);
  const [responsabiliDisponibili, setResponsabiliDisponibili] = useState([]);
  const [loadingResponsabili, setLoadingResponsabili] = useState(false);
  const [provinciaSearch, setProvinciaSearch] = useState('');
  const [cittaSearch, setCittaSearch] = useState('');
  const [availableComuni, setAvailableComuni] = useState([]);
  const [filteredComuni, setFilteredComuni] = useState([]);
  const [loadingComuni, setLoadingComuni] = useState(false);
  
  // Filtra le province in base alla ricerca
  const filteredProvince = PROVINCE_ITALIANE.filter(provincia => 
    provincia.nome.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.sigla.toLowerCase().includes(provinciaSearch.toLowerCase()) ||
    provincia.regione.toLowerCase().includes(provinciaSearch.toLowerCase())
  );

  // Trova la provincia selezionata per mostrare il nome completo
  const selectedProvincia = PROVINCE_ITALIANE.find(p => p.sigla === formData.provincia);
  const provinciaDisplayText = selectedProvincia 
    ? `${selectedProvincia.nome} (${selectedProvincia.sigla}) - ${selectedProvincia.regione}`
    : '';

  // Carica i comuni quando cambia la provincia
  useEffect(() => {
    const loadComuni = async () => {
      if (formData.provincia) {
        setLoadingComuni(true);
        try {
          const comuni = await getComuniByProvincia(formData.provincia);
          setAvailableComuni(comuni);
          setFilteredComuni(comuni);
        } catch (error) {
          console.error('Errore nel caricamento comuni:', error);
          setAvailableComuni(getDefaultComuni());
          setFilteredComuni(getDefaultComuni());
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setAvailableComuni(getDefaultComuni());
        setFilteredComuni(getDefaultComuni());
      }
    };
    
    loadComuni();
  }, [formData.provincia]);

  // Filtra i comuni in base alla ricerca
  useEffect(() => {
    const filterComuni = async () => {
      if (cittaSearch.length >= 2 && formData.provincia) {
        setLoadingComuni(true);
        try {
          const risultati = await searchComuni(cittaSearch, formData.provincia);
          setFilteredComuni(risultati);
        } catch (error) {
          console.error('Errore nella ricerca comuni:', error);
          setFilteredComuni([]);
        } finally {
          setLoadingComuni(false);
        }
      } else {
        setFilteredComuni(availableComuni);
      }
    };
    
    const debounceTimer = setTimeout(filterComuni, 300);
    return () => clearTimeout(debounceTimer);
  }, [cittaSearch, availableComuni, formData.provincia]);
  
  // Carica i responsabili disponibili dall'API
  useEffect(() => {
    const fetchResponsabili = async () => {
      try {
        setLoadingResponsabili(true);
        
        // Carica i responsabili disponibili dal server
        const response = await api.get('/clienti/responsabili/disponibili');
        if (response.data && response.data.success) {
          // I dati ora sono raggruppati per categoria
          setResponsabiliDisponibili(response.data.data);
        } else {
          // Fallback all'endpoint delle agenzie se il nuovo non funziona
          const fallbackResponse = await api.get('/pratica/agenzie');
          if (fallbackResponse.data && fallbackResponse.data.agenzie) {
            const agenzieFormatted = {
              'Agenzia': fallbackResponse.data.agenzie.map(agenzia => ({
                id: agenzia.id,
                nome: agenzia.nome,
                ruolo: 'agenzia',
                tipoNodo: 'agenzia_primaria'
              }))
            };
            setResponsabiliDisponibili(agenzieFormatted);
          }
        }
      } catch (error) {
        console.error('Errore nel caricamento responsabili:', error);
        setError('Errore nel caricamento dei responsabili disponibili');
      } finally {
        setLoadingResponsabili(false);
      }
    };
    
    fetchResponsabili();
  }, []);
  
  // Se in modalità modifica, carica i dati del cliente
  useEffect(() => {
    if (isEditing) {
      loadClient();
    }
  }, [id]);

  // Chiudi dropdown quando si clicca fuori
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('[data-dropdown]')) {
        setShowOwnerDropdown(false);
        setShowProvinciaDropdown(false);
        setShowCittaDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  const loadClient = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/clienti/${id}`);
      setFormData(response.data);
    } catch (err) {
      console.error('Errore nel caricamento del cliente:', err);
      setError(typeof err === 'object' && err !== null ? 
        (err.response?.data?.error || err.message || 'Errore nel caricamento del cliente') : 
        'Errore nel caricamento del cliente');
    } finally {
      setLoading(false);
    }
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Reset del messaggio di errore per il campo modificato
    if (validationErrors[name]) {
      setValidationErrors(prev => ({
        ...prev,
        [name]: null
      }));
    }
  };
  
  const validateForm = () => {
    const errors = {};
    
    // Validazione tipo cliente
    if (!formData.tipo_cliente) {
      errors.tipo_cliente = 'Il tipo cliente è obbligatorio';
    }
    
    // Validazione dei campi obbligatori
    if (formData.tipo_cliente === 'privato') {
      // Nome e cognome sono sempre obbligatori per clienti privati
      if (!formData.nome) {
        errors.nome = 'Il nome è obbligatorio';
      }
      if (!formData.cognome) {
        errors.cognome = 'Il cognome è obbligatorio';
      }
    } else if (formData.tipo_cliente === 'azienda') {
      // Per i clienti aziendali, la ragione sociale è obbligatoria
      if (!formData.ragione_sociale) {
        errors.ragione_sociale = 'La ragione sociale è obbligatoria';
      }
    }
    
    // Validazione email
    if (!formData.email) {
      errors.email = 'L\'email è obbligatoria';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email non valida';
    }
    
    // Validazione telefono
    if (!formData.telefono) {
      errors.telefono = 'Il telefono è obbligatorio';
    }
    
    // Validazioni non bloccanti
    if (formData.codice_fiscale && formData.codice_fiscale.length !== 16) {
      errors.codice_fiscale = 'Il codice fiscale deve essere di 16 caratteri';
    }
    
    if (formData.partita_iva && formData.partita_iva.length !== 11) {
      errors.partita_iva = 'La partita IVA deve essere di 11 caratteri';
    }
    
    if (formData.provincia && formData.provincia.length !== 2) {
      errors.provincia = 'La provincia deve essere di 2 caratteri';
    }
    
    if (formData.cap && formData.cap.length !== 5) {
      errors.cap = 'Il CAP deve essere di 5 caratteri';
    }
    
    if (formData.iban && (formData.iban.length < 27 || formData.iban.length > 34)) {
      errors.iban = 'IBAN non valido';
    }
    
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSelectOwner = (responsabile) => {
    setFormData(prev => ({
      ...prev,
      responsabileId: responsabile.id,
      responsabileNome: responsabile.nome // Mantieni il nome per la visualizzazione
    }));
    setShowOwnerDropdown(false);
  };

  const handleSelectProvincia = (provincia) => {
    setFormData(prev => ({
      ...prev,
      provincia: provincia.sigla,
      citta: '', // Reset della città quando cambia provincia
      cap: '' // Reset del CAP quando cambia provincia
    }));
    setShowProvinciaDropdown(false);
    setProvinciaSearch('');
  };

  const handleSelectCitta = (comune) => {
    setFormData(prev => ({
      ...prev,
      citta: comune.nome,
      cap: comune.cap || prev.cap // Imposta il CAP se disponibile
    }));
    setShowCittaDropdown(false);
    setCittaSearch('');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      // Scroll verso il primo errore
      const firstError = document.querySelector('.text-red-500');
      if (firstError) {
        firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    
    try {
      setSaving(true);
      setError(null);
      setValidationErrors({});
      
      // Prepara i dati per l'API
      const clientData = { ...formData };
      
      if (isEditing) {
        await api.put(`/clienti/${id}`, clientData);
      } else {
        await api.post('/clienti', clientData);
      }
      
      // Aggiungiamo un breve ritardo prima del redirect per garantire che i dati siano aggiornati
      setTimeout(() => {
        // Redirect alla lista clienti dopo il salvataggio
        navigate('/nlt/clienti');
      }, 500);
      
    } catch (err) {
      console.error('Errore nel salvataggio del cliente:', err);
      
      // Gestione più robusta degli errori
      if (err && err.response && err.response.data) {
        const responseData = err.response.data;
        
        if (responseData.errors && Array.isArray(responseData.errors)) {
          // Gestiamo gli errori specifici per campo
          const serverErrors = {};
          
          responseData.errors.forEach(error => {
            // Controlliamo se l'errore è un oggetto con field e message
            if (typeof error === 'object' && error !== null) {
              if (error.field && error.message) {
                serverErrors[error.field] = error.message;
              } else {
                // Se è un oggetto ma senza field/message, prendiamo le proprietà disponibili
                const errorMessage = error.message || error.error || JSON.stringify(error);
                if (!serverErrors.general) serverErrors.general = [];
                serverErrors.general.push(errorMessage);
              }
            } else if (typeof error === 'string') {
              // Se l'errore è una stringa
              if (!serverErrors.general) serverErrors.general = [];
              serverErrors.general.push(error);
            }
          });
          
          if (Object.keys(serverErrors).length > 0) {
            if (serverErrors.general) {
              // Mostriamo gli errori generali in alto
              setError(serverErrors.general.join(', '));
              delete serverErrors.general;
            }
            
            if (Object.keys(serverErrors).length > 0) {
              // Se ci sono ancora errori specifici per campo
              setValidationErrors(serverErrors);
              
              // Scroll al primo errore
              setTimeout(() => {
                const firstError = document.querySelector('.text-red-500');
                if (firstError) {
                  firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              }, 100);
            }
          } else {
            // Se non riusciamo a parsare gli errori in modo strutturato
            setError('Si sono verificati degli errori. Verifica i dati inseriti.');
          }
        } else if (responseData.error) {
          // Errore generale
          setError(responseData.error);
        } else if (responseData.message) {
          // Alcuni API restituiscono errori con message invece di error
          setError(responseData.message);
        } else {
          // Se responseData è un oggetto ma non ha proprietà strutturate
          setError('Errore nella creazione del cliente. Verifica i dati inseriti.');
        }
      } else if (err && err.message) {
        // Errore di rete o altro errore con messaggio
        setError(`Errore: ${err.message}`);
      } else {
        // Fallback per qualsiasi altro caso
        setError('Si è verificato un errore imprevisto. Riprova più tardi.');
      }
      
      window.scrollTo(0, 0); // Scroll to top to show error
    } finally {
      setSaving(false);
    }
  };
  
  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Caricamento cliente...</p>
      </div>
    );
  }

  return (
    <div className="w-full max-w-5xl mx-auto">
      {/* Breadcrumb */}
      <nav className="flex mb-6" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link to="/nlt/" className="text-blue-600 hover:text-blue-800">
              Dashboard
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon className="h-4 w-4 text-gray-400" />
              <Link to="/nlt/clienti" className="ml-1 text-blue-600 hover:text-blue-800">
                Clienti
              </Link>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <ChevronRightIcon className="h-4 w-4 text-gray-400" />
              <span className="ml-1 text-gray-500" aria-current="page">
                {isEditing ? 'Modifica cliente' : 'Nuovo cliente'}
              </span>
            </div>
          </li>
        </ol>
      </nav>

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          {isEditing ? 'Modifica cliente' : 'Nuovo cliente'}
        </h1>
      </div>
      
      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          {error}
        </div>
      )}
      
      {Object.keys(validationErrors).length > 0 && !error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
          <p className="font-medium mb-2">Correggi i seguenti errori:</p>
          <ul className="list-disc list-inside">
            {Object.values(validationErrors).map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </div>
      )}
      
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        {/* Messaggio informativo */}
        <div className="bg-blue-50 p-4 border-b border-blue-100">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <InformationCircleIcon className="h-5 w-5 text-blue-600" />
            </div>
            <div className="ml-3">
              <p className="text-sm text-blue-700">
                Inserisci tutti i dati per creare un nuovo cliente. I campi marcati con * sono obbligatori.
              </p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {/* Tipo cliente */}
          <div className="mb-8">
            <label className="block text-gray-700 text-sm font-bold mb-3">
              Tipo cliente
            </label>
            <div className="flex space-x-6">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="tipo_cliente"
                  value="privato"
                  checked={formData.tipo_cliente === 'privato'}
                  onChange={handleChange}
                  className="form-radio h-5 w-5 text-blue-600"
                />
                <span className="ml-2 text-gray-700">Privato</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="tipo_cliente"
                  value="azienda"
                  checked={formData.tipo_cliente === 'azienda'}
                  onChange={handleChange}
                  className="form-radio h-5 w-5 text-blue-600"
                />
                <span className="ml-2 text-gray-700">Azienda</span>
              </label>
            </div>
            {validationErrors.tipo_cliente && (
              <p className="text-red-500 text-xs mt-1">{validationErrors.tipo_cliente}</p>
            )}
          </div>

          {/* Responsabile */}
          <div className="mb-8">
            <div className="flex justify-between items-center mb-3">
              <label className="block text-gray-700 text-sm font-bold" htmlFor="responsabileId">
                Responsabile
              </label>
            </div>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
              </div>
                              <input
                  id="responsabileId"
                  name="responsabileId"
                  type="text"
                  value={formData.responsabileNome || 
                    (formData.responsabileId ? 
                      // Cerca nelle categorie raggruppate
                      Object.values(responsabiliDisponibili || {}).flat().find(r => r.id === formData.responsabileId)?.nome || 'Responsabile selezionato' 
                      : '')}
                  readOnly
                  placeholder={loadingResponsabili ? "Caricamento..." : "Seleziona un responsabile"}
                  className={`w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md cursor-pointer bg-white focus:outline-none focus:ring-blue-500 focus:border-blue-500 ${loadingResponsabili ? 'opacity-50' : ''}`}
                  onClick={() => !loadingResponsabili && setShowOwnerDropdown(!showOwnerDropdown)}
                />
                              {showOwnerDropdown && !loadingResponsabili && (
                  <div data-dropdown className="absolute z-10 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                    {responsabiliDisponibili && Object.keys(responsabiliDisponibili).length > 0 ? (
                      Object.entries(responsabiliDisponibili).map(([categoria, responsabili]) => (
                        <div key={categoria}>
                          {/* Header categoria */}
                          <div className="px-4 py-2 bg-gray-50 border-b border-gray-200 font-semibold text-gray-700 text-sm uppercase tracking-wide">
                            {categoria}
                          </div>
                          {/* Responsabili della categoria */}
                          {responsabili.map(responsabile => (
                            <div 
                              key={responsabile.id}
                              className="px-4 py-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                              onClick={() => handleSelectOwner(responsabile)}
                            >
                              <div className="flex items-center">
                                {/* Indentazione per la gerarchia - solo per agenti */}
                                {responsabile.tipoNodo === 'agente' && (
                                  <div className="w-4 text-gray-400 text-xs mr-1">└─</div>
                                )}
                                
                                <div className="flex-1">
                                  <div className="font-medium text-gray-900">{responsabile.nome}</div>
                                  <div className="text-sm text-gray-500 flex items-center gap-2">
                                    {responsabile.tipoNodo && (
                                      <span className={`inline-flex px-2 py-1 text-xs rounded-full ${
                                        responsabile.tipoNodo === 'agenzia_primaria' ? 'bg-purple-100 text-purple-800' :
                                        responsabile.tipoNodo === 'team_leader' ? 'bg-blue-100 text-blue-800' :
                                        responsabile.tipoNodo === 'agente' ? 'bg-green-100 text-green-800' :
                                        'bg-gray-100 text-gray-800'
                                      }`}>
                                        {responsabile.tipoNodo === 'agenzia_primaria' ? 'Agenzia Primaria' :
                                         responsabile.tipoNodo === 'team_leader' ? 'Team Leader' :
                                         responsabile.tipoNodo === 'agente' ? 'Agente' : 
                                         responsabile.ruolo}
                                      </span>
                                    )}
                                    {responsabile.parentInfo && (
                                      <span className="text-xs text-gray-400">
                                        sotto {responsabile.parentInfo.nome}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-3 text-gray-500 text-center">
                        Nessun responsabile disponibile
                      </div>
                    )}
                  </div>
                )}
            </div>
          </div>

          {formData.tipo_cliente === 'privato' ? (
            <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Nome */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="nome">
                  Nome*
                </label>
                <input
                  id="nome"
                  name="nome"
                  type="text"
                  value={formData.nome}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.nome ? 'border-red-500' : 'border-gray-300'} rounded`}
                />
                {validationErrors.nome && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.nome}</p>
                )}
              </div>
              
              {/* Cognome */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cognome">
                  Cognome*
                </label>
                <input
                  id="cognome"
                  name="cognome"
                  type="text"
                  value={formData.cognome}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.cognome ? 'border-red-500' : 'border-gray-300'} rounded`}
                />
                {validationErrors.cognome && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.cognome}</p>
                )}
              </div>
              
              {/* Codice Fiscale */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="codice_fiscale">
                  Codice Fiscale
                </label>
                <input
                  id="codice_fiscale"
                  name="codice_fiscale"
                  type="text"
                  value={formData.codice_fiscale}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.codice_fiscale ? 'border-red-500' : 'border-gray-300'} rounded uppercase`}
                  maxLength={16}
                />
                {validationErrors.codice_fiscale && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.codice_fiscale}</p>
                )}
              </div>
              
              {/* Tipo Contratto */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipo_contratto">
                  Tipo di contratto
                </label>
                <select
                  id="tipo_contratto"
                  name="tipo_contratto"
                  value={formData.tipo_contratto || ''}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  <option value="">Seleziona...</option>
                  <option value="tempo_indeterminato">Dipendente con contratto a tempo Indeterminato</option>
                  <option value="tempo_indeterminato_meno_6_mesi">Dipendente con contratto a tempo Indeterminato da meno di 6 mesi</option>
                  <option value="pensionato">Pensionato</option>
                  <option value="reddito_modello_unico">Privato con reddito modello unico</option>
                </select>
              </div>
            </div>
          ) : (
            <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Ragione Sociale */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="ragione_sociale">
                  Ragione Sociale*
                </label>
                <input
                  id="ragione_sociale"
                  name="ragione_sociale"
                  type="text"
                  value={formData.ragione_sociale}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.ragione_sociale ? 'border-red-500' : 'border-gray-300'} rounded`}
                />
                {validationErrors.ragione_sociale && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.ragione_sociale}</p>
                )}
              </div>
              
              {/* Partita IVA */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="partita_iva">
                  Partita IVA
                </label>
                <input
                  id="partita_iva"
                  name="partita_iva"
                  type="text"
                  value={formData.partita_iva}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.partita_iva ? 'border-red-500' : 'border-gray-300'} rounded`}
                  maxLength={11}
                />
                {validationErrors.partita_iva && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.partita_iva}</p>
                )}
              </div>
              
              {/* Tipo Società Dettaglio - NUOVO CAMPO OBBLIGATORIO */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipo_societa_dettaglio">
                  Tipologia Azienda* 
                  <span className="text-xs font-normal text-gray-500 ml-2">(Determina i documenti richiesti)</span>
                </label>
                <select
                  id="tipo_societa_dettaglio"
                  name="tipo_societa_dettaglio"
                  value={formData.tipo_societa_dettaglio || ''}
                  onChange={handleChange}
                  className={`w-full p-2 border ${validationErrors.tipo_societa_dettaglio ? 'border-red-500' : 'border-gray-300'} rounded`}
                  required
                >
                  <option value="">Seleziona tipologia...</option>
                  <optgroup label="Professionisti e Imprese Individuali">
                    <option value="libero_professionista">Libero Professionista</option>
                    <option value="ditta_individuale">Ditta Individuale</option>
                  </optgroup>
                  <optgroup label="Società">
                    <option value="societa_persone">Società di Persone (SNC, SAS)</option>
                    <option value="societa_capitali">Società di Capitali (SRL, SPA, SAPA)</option>
                    <option value="societa_estere">Società Estera</option>
                  </optgroup>
                  <optgroup label="Enti e Altri">
                    <option value="consorzi_onlus">Consorzio / ONLUS / Associazione</option>
                    <option value="pensionati">Pensionato (come azienda)</option>
                  </optgroup>
                </select>
                {validationErrors.tipo_societa_dettaglio && (
                  <p className="text-red-500 text-xs mt-1">{validationErrors.tipo_societa_dettaglio}</p>
                )}
                <p className="text-xs text-gray-500 mt-1">
                  ⚠️ Questa selezione determina quali documenti saranno richiesti per la pratica
                </p>
              </div>
              
              {/* Tipo Società */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tipo_societa">
                  Tipo di società
                </label>
                <select
                  id="tipo_societa"
                  name="tipo_societa"
                  value={formData.tipo_societa || ''}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                >
                  <option value="">Seleziona...</option>
                  <option value="libero_professionista_neocostituita">Libero professionista o società neocostituita</option>
                  <option value="libero_professionista_meno_2_bilanci">Libero professionista o società con meno di 2 bilanci depositati</option>
                  <option value="libero_professionista_piu_2_bilanci">Libero professionista o società con più di 2 bilanci depositati</option>
                </select>
              </div>
              
              {/* Referente */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="referente">
                  Referente
                </label>
                <input
                  id="referente"
                  name="referente"
                  type="text"
                  value={formData.referente}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              
              {/* PEC */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="pec">
                  PEC
                </label>
                <input
                  id="pec"
                  name="pec"
                  type="email"
                  value={formData.pec}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                />
              </div>
              
              {/* Codice Univoco */}
              <div>
                <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="codice_univoco">
                  Codice Univoco
                </label>
                <input
                  id="codice_univoco"
                  name="codice_univoco"
                  type="text"
                  value={formData.codice_univoco}
                  onChange={handleChange}
                  className="w-full p-2 border border-gray-300 rounded"
                  maxLength={7}
                />
              </div>
            </div>
          )}
          
          {/* Sezione informazioni di contatto */}
          <h3 className="text-xl font-semibold text-gray-700 mb-4 border-b pb-2 mt-6">Informazioni di Contatto</h3>
          
          <div className="mb-6 grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Provincia */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="provincia">
                Provincia
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="provincia"
                  name="provincia"
                  type="text"
                  value={provinciaDisplayText}
                  readOnly
                  placeholder="Seleziona una provincia"
                  className={`w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md cursor-pointer bg-white focus:outline-none focus:ring-blue-500 focus:border-blue-500`}
                  onClick={() => setShowProvinciaDropdown(!showProvinciaDropdown)}
                />
                {showProvinciaDropdown && (
                  <div data-dropdown className="absolute z-10 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                    <div className="p-2 border-b">
                      <input
                        type="text"
                        placeholder="Cerca provincia, sigla o regione..."
                        value={provinciaSearch}
                        onChange={(e) => setProvinciaSearch(e.target.value)}
                        className="w-full p-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </div>
                    {filteredProvince.map(provincia => (
                      <div 
                        key={provincia.codice}
                        className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                        onClick={() => handleSelectProvincia(provincia)}
                      >
                        <div className="font-medium">{provincia.nome} ({provincia.sigla})</div>
                        <div className="text-sm text-gray-500">{provincia.regione}</div>
                      </div>
                    ))}
                    {filteredProvince.length === 0 && (
                      <div className="px-4 py-2 text-gray-500 text-sm">
                        Nessuna provincia trovata
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* Città */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="citta">
                Città
              </label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="citta"
                  name="citta"
                  type="text"
                  value={formData.citta}
                  onChange={(e) => {
                    handleChange(e);
                    setCittaSearch(e.target.value);
                    setShowCittaDropdown(true);
                  }}
                  onFocus={() => setShowCittaDropdown(true)}
                  placeholder={formData.provincia ? "Cerca o seleziona città..." : "Seleziona prima una provincia"}
                  className="w-full py-2 pl-10 pr-3 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  disabled={!formData.provincia}
                />
                {showCittaDropdown && formData.provincia && (
                  <div data-dropdown className="absolute z-10 mt-1 w-full bg-white rounded-md shadow-lg border border-gray-200 max-h-60 overflow-y-auto">
                    {loadingComuni ? (
                      <div className="px-4 py-2 text-gray-500 text-sm flex items-center">
                        <span className="animate-spin h-4 w-4 mr-2 border-b-2 border-blue-500 rounded-full"></span>
                        Caricamento comuni...
                      </div>
                    ) : filteredComuni.length > 0 ? (
                      filteredComuni.map((comune, index) => (
                        <div 
                          key={`${comune.nome}-${index}`}
                          className="px-4 py-2 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                          onClick={() => handleSelectCitta(comune)}
                        >
                          <div className="font-medium">{comune.nome}</div>
                          {comune.cap && <div className="text-sm text-gray-500">CAP: {comune.cap}</div>}
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-gray-500 text-sm">
                        {cittaSearch.length < 2 
                          ? "Digita almeno 2 caratteri per cercare" 
                          : "Nessuna città trovata"}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            
            {/* Indirizzo */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="indirizzo">
                Indirizzo
              </label>
              <input
                id="indirizzo"
                name="indirizzo"
                type="text"
                value={formData.indirizzo}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded"
              />
            </div>
            
            {/* CAP */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="cap">
                CAP
              </label>
              <input
                id="cap"
                name="cap"
                type="text"
                value={formData.cap}
                onChange={handleChange}
                className={`w-full p-2 border ${validationErrors.cap ? 'border-red-500' : 'border-gray-300'} rounded`}
                maxLength={5}
              />
              {validationErrors.cap && (
                <p className="text-red-500 text-xs mt-1">{validationErrors.cap}</p>
              )}
            </div>
            
            {/* Email */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                Email*
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full p-2 border ${validationErrors.email ? 'border-red-500' : 'border-gray-300'} rounded`}
              />
              {validationErrors.email && (
                <p className="text-red-500 text-xs mt-1">{validationErrors.email}</p>
              )}
            </div>
            
            {/* Telefono */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="telefono">
                Telefono*
              </label>
              <input
                id="telefono"
                name="telefono"
                type="tel"
                value={formData.telefono}
                onChange={handleChange}
                className={`w-full p-2 border ${validationErrors.telefono ? 'border-red-500' : 'border-gray-300'} rounded`}
              />
              {validationErrors.telefono && (
                <p className="text-red-500 text-xs mt-1">{validationErrors.telefono}</p>
              )}
            </div>
            
            {/* IBAN */}
            <div>
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="iban">
                IBAN
              </label>
              <input
                id="iban"
                name="iban"
                type="text"
                value={formData.iban}
                onChange={handleChange}
                className={`w-full p-2 border ${validationErrors.iban ? 'border-red-500' : 'border-gray-300'} rounded uppercase`}
              />
              {validationErrors.iban && (
                <p className="text-red-500 text-xs mt-1">{validationErrors.iban}</p>
              )}
            </div>
          </div>
          
          {/* Stato (solo in modifica) */}
          {isEditing && (
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="stato">
                Stato
              </label>
              <select
                id="stato"
                name="stato"
                value={formData.stato}
                onChange={handleChange}
                className="w-full p-2 border border-gray-300 rounded"
              >
                <option value="prospect">Prospect</option>
                <option value="qualificato">Qualificato</option>
                <option value="attivo">Attivo</option>
              </select>
            </div>
          )}
          
          {/* Pulsanti */}
          <div className="flex justify-end space-x-4 mt-8 border-t pt-6">
            <button
              type="button"
              onClick={() => navigate('/nlt/clienti')}
              className="bg-white hover:bg-gray-100 text-gray-700 font-medium py-2 px-4 border border-gray-300 rounded-md"
            >
              Annulla
            </button>
            <button
              type="submit"
              disabled={saving}
              className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-md flex items-center"
            >
              {saving ? (
                <>
                  <span className="animate-spin h-4 w-4 mr-2 border-b-2 border-white rounded-full"></span>
                  Salvataggio...
                </>
              ) : (
                'Salva'
              )}
            </button>
          </div>
          
          <p className="text-gray-500 text-sm mt-4">* Campi obbligatori</p>
        </form>
      </div>
    </div>
  );
};

export default ClientForm; 